import { render, staticRenderFns } from "./FilterPrompt.vue?vue&type=template&id=64b48650&"
import script from "./FilterPrompt.vue?vue&type=script&lang=js&"
export * from "./FilterPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports